import { Button } from '@progress/kendo-react-buttons'
import { DatePicker, DateTimePicker, MultiViewCalendar, MultiViewCalendarProps } from '@progress/kendo-react-dateinputs'
import { ComboBox, ComboBoxFilterChangeEvent } from '@progress/kendo-react-dropdowns'
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from '@progress/kendo-react-form'
import { Input, RadioGroup } from '@progress/kendo-react-inputs'
import { MouseEvent as ReactMouseEvent, useEffect, useState } from 'react'
import SessionStorageService from '../../services/SessionStorageService'
import {
  arhs,
  capitania,
  concelhos,
  coordenadasPoligono,
  coordenadasSelected,
  deposicaoLocal1,
  deposicaoLocal2,
  deposicaoObjetivo1,
  deposicaoObjetivo2,
  distritos,
  entidades,
  fillArhsAsync,
  fillCapitaniaAsync,
  fillCombosAuxiliares,
  fillConcelhosAsync,
  fillDeposicaoNivel1Async,
  fillDeposicaoNivel2Async,
  fillDistritosAsync,
  fillEntidadesAsync,
  fillFreguesiasAsync,
  fillMetodoDeposicaoAsync,
  fillMetodoDragagemAsync,
  fillMobilizacaoEstadoAsync,
  fillMobilizacaoFuncoesAsync,
  fillMobilizacaoTipologiaAsync,
  fillNuts1Async,
  fillNuts2Async,
  fillNuts3Async,
  fillObjetivoDeposicao1Async,
  fillObjetivoDeposicao2Async,
  fillQualidadeSedimentosAsync,
  freguesias,
  hasPermission,
  mancha1,
  mancha2,
  metodoDeposicao,
  metotodoDragagem,
  mobilizacaoEstado,
  mobilizacaoFuncoes,
  nuts1,
  nuts2,
  nuts3,
  post,
  qualidadeSedimentos,
  selectCriterioGeograficoNenhum,
  setCoordenadasPoligono,
  tecnicos,
  tipologiaMob,
  tiposMobilizacao,
  useCombos,
  userLoggedObject
} from '../../services/utils'
import styles from '../../styles/intervencao/Intervencao.module.scss'
import { AREA_VISIVEL, AUTH_LOCALSTORAGE, CONSULTAR_MOBILIZACAO, NENHUM, PERMISSION_INTERVENCAO_PERFIL_BASICO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_TOTAL, POLIGONO_SELECAO, clearLayers } from '../../utils/constants'
import FieldsetCombosLocalizacao from '../localizacao/FieldsetCombosLocalizacao'
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query'
import ReactGA from 'react-ga4';

type Props = {
  onCloseClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
  onClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
}

export default function PesquisarMobilizacao({ onCloseClick, onClick }: Props) {
  const [registoVisible, setRegistoVisible] = useState(true)
  const toggleRegisto = () =>
    setRegistoVisible((previousState) => !previousState)

  const [criterioGeograficoVisible, setCriterioGeograficoVisible] =
    useState(false)
  const toggleCriterioGeografico = () => {
    setCriterioGeograficoVisible((previousState) => !previousState)
  }

  const [localizacaoVisible, setLocalizacaoVisible] = useState(false)
  const toggleLocalizacao = () => {
    setLocalizacaoVisible((previousState) => !previousState)
  }

  const [identificacaoVisible, setIdentificacaoVisible] = useState(false)
  const toggleIdentificacao = () => {
    setIdentificacaoVisible((previousState) => !previousState)
  }

  
  const [tipologiaVisible, setTipologiaVisible] = useState(false)
  const toggleTipologia = () => {
    setTipologiaVisible((previousState) => !previousState)
  }

  const [caracterizacaoVisible, setCaracterizacaoVisible] = useState(false)
  const toggleCaracterizacao = () => {
    setCaracterizacaoVisible((previousState) => !previousState)
  }

  const [intervaloVisible, setIntervaloVisible] = useState(false)
  const toggleIntervalo = () => {
    setIntervaloVisible((previousState) => !previousState)
  }

  const [estadoVisible, setEstadoVisible] = useState(false)
  const toggleEstado = () => {
    setEstadoVisible((previousState) => !previousState)
  }

  const [entidadeVisible, setEntidadeVisible] = useState(false)
  const toggleEntidade = () => {
    setEntidadeVisible((previousState) => !previousState)
  }
  const [rbCriteriosSelected, setRBCriteriosSelected] = useState<any>()

  const [concelhosFiltred, setConcelhosFiltred] = useState<any>(undefined)
  const [concelhosDisabled, setConcelhosDisabled] = useState<any>(true)
  const [freguesiasFiltred, setFreguesiasFiltred] = useState<any>(undefined)
  const [freguesiasDisabled, setFreguesiasDisabled] = useState<any>(true)
  const [nuts2Filtered, setNuts2Filtered] = useState<any>(undefined)
  const [nuts2Disabled, setNuts2Disabled] = useState<any>(true)
  const [nuts3Filtered, setNuts3Filtered] = useState<any>(undefined)
  const [nuts3Disabled, setNuts3Disabled] = useState<any>(true)
  const [tecnicosData, setTecnicosData] = useState<any>(tecnicos ? tecnicos.slice() : []);
  const [deposicaoNivel1Selected, setDeposicaoNivel1Selected] = useState<any>();
  const [deposicaoNivel2Selected, setDeposicaoNivel2Selected] = useState<any>();
  const[deposicaoNive2Filtred, setDeposicaoNive2Filtred] = useState<any>();
  const [tipologia, setTipologia] = useState<any>();
  const [tipologiaExtracaoSelected, setTipologiaExtracaoSelected] = useState(false);
  const [tipologiaDeposicaoSelected, setTipologiaDeposicaoSelected] = useState(false)


  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/PesquisarIntMobilizacao" });
  }, []);

    useEffect(() => {
    
      if(!nuts1 ){
        fillNuts1Async();
        }
       if(!nuts2) {
        fillNuts2Async();
       }
       if(!nuts3){
        fillNuts3Async();
       }
       if(!distritos){
        fillDistritosAsync();
       }
       if(!concelhos){
        fillConcelhosAsync();
       }
       if(!freguesias){
        fillFreguesiasAsync();
       }
       if(!arhs){
        fillArhsAsync();
       }
       if(!capitania){
        fillCapitaniaAsync();
       }
       if(!mobilizacaoFuncoes){
        fillMobilizacaoFuncoesAsync();
       }
       if(!tipologiaMob){
        fillMobilizacaoTipologiaAsync();
       }
       if(!deposicaoLocal1){
        fillDeposicaoNivel1Async();
       }
       if(!deposicaoLocal2){
        fillDeposicaoNivel2Async();
       }
       if(!entidades){
        fillEntidadesAsync();
       }
       if(!mobilizacaoEstado){
        fillMobilizacaoEstadoAsync();
       }
       if(!metotodoDragagem){
        fillMetodoDragagemAsync();
       }
       if(!metodoDeposicao){
        fillMetodoDeposicaoAsync();
       }
       if(!deposicaoObjetivo1){
        fillObjetivoDeposicao1Async();
       }
        if(!deposicaoObjetivo2){
        fillObjetivoDeposicao2Async();
       }
       if(!qualidadeSedimentos){
        fillQualidadeSedimentosAsync();
       }
    

  }, []);

  const filterDataTecnicos = (filter: FilterDescriptor) => {
    const data = tecnicos.slice();
    return filterBy(data, filter);
  };

  const filterChangeTecnicos = (event: ComboBoxFilterChangeEvent) => {
    setTecnicosData(filterDataTecnicos(event.filter));
  };

  const filterConcelho = (e: any) => {
    if (e?.value?.codigo) {
      const concelhosLocal = concelhos.filter(
        (x: any) => x.distrito_cod == e.value.codigo
      )
      setConcelhosFiltred(concelhosLocal)
      setConcelhosDisabled(false)
    } else {
      setConcelhosFiltred(concelhos)
      setConcelhosDisabled(true)
    }
  }

  const filterFreguesia = (e: any) => {
    if (e?.value?.codigo) {
      const freguesiaLocal = freguesias.filter(
        (x: any) => x.concelho_cod == e.value.codigo
      )
      setFreguesiasFiltred(freguesiaLocal)
      setFreguesiasDisabled(false)
    } else {
      setFreguesiasDisabled(true)
      setFreguesiasFiltred(freguesias)
    }
  }

  const filterNuts2 = (e: any) => {
    if (e?.value?.codigo) {
      const nutsLocal = nuts2.filter((x: any) => x.nuts_i_cod == e.value.codigo)
      setNuts2Filtered(nutsLocal)
      setNuts2Disabled(false)
    } else {
      setNuts2Disabled(true)
      setNuts2Filtered(nuts2)
    }
  }

  const filterNuts3 = (e: any) => {
    if (e?.value?.codigo) {
      const nutsLocal = nuts3.filter(
        (x: any) => x.nuts_ii_cod == e.value.codigo
      )
      setNuts3Filtered(nutsLocal)
      setNuts3Disabled(false)
    } else {
      setNuts3Disabled(true)
      setNuts3Filtered(nuts3)
    }
  }

  const changerbCriterio = (e: any) => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage({ type: "SiarlDeselectMapArea", value: 'true' }, '*')
    if (e.value == POLIGONO_SELECAO) {
        postMessage(
            { type: 'informationMsg', value: 'Selecione a área de pesquisa' },
            '*'
        )
        const iframe: any = document.getElementById('iframeGeoPortal')
        iframe.contentWindow?.postMessage(
            { type: 'SiarlGeoPortalAdicionarArea', value: 'true' },
            '*'
        )
    }
    if (e.value == AREA_VISIVEL) {
        iframe.contentWindow?.postMessage({ type: "SiarlSelectMapArea", value: 'true' }, '*')
        postMessage(
            {
                type: 'informationMsg',
                value: 'Foi selecionada a área visível do mapa',
            },
            '*'
        )
       
        iframe.contentWindow?.postMessage(
            { type: 'SiarlGetMapArea', value: 'true' },
            '*'
        )
    }
    if (e.value == NENHUM) {
      selectCriterioGeograficoNenhum()
    }
}


const clearMap = () => {
  try {

    setCoordenadasPoligono(undefined)
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage({ type: "SiarlIntMobilizacaoClearLayers", value: "true" }, '*')
    iframe.contentWindow?.postMessage({ type: "SiarlRemoveSelection", value: "true" }, '*')
    iframe.contentWindow?.postMessage({ type: "SiarlDeselectMapArea", value: "true" }, '*')

  } catch (error) {
    console.log({ error })
  }
}

  const getMobilizacao = async (data: any) =>
    await post<any, any>(`${CONSULTAR_MOBILIZACAO}`, data)

  const loggedUser = userLoggedObject();

  const handleSubmit = async (e: any) => {
    postMessage({ type: 'showLoader' }, '*')

    console.log(e);
    const objToSearch = {
      id: e.values?.id?.trim() == "" ? undefined : e.values?.id,
      descricao: e.values?.descricao,
      id_tipo_mo: e.values?.tipo_mo ? e.values?.tipo_mo.id : undefined,
      funcao_id: e.values?.funcao ? e.values?.funcao.id : undefined,
      tipo_local_deposicao_1_id: e.values?.tipo_local_deposicao_1_id
        ? e.values?.tipo_local_deposicao_1_id.id
        : undefined,
      tipo_local_deposicao_2_id: e.values?.tipo_local_deposicao_2_id
        ? e.values?.tipo_local_deposicao_2_id.id
        : undefined,
      arh_cod: e.values.arh ? e.values?.arh.codigo : undefined,
      freguesia_cod: e.values.freguesia?.codigo ?? undefined,
      concelho_cod: e.values.concelho?.codigo ?? undefined,
      distrito_cod: e.values.distrito?.codigo ?? undefined,
      nuts1_cod: e.values?.nuts1?.codigo ?? undefined,
      nuts2_cod: e.values?.nuts2?.codigo ?? undefined,
      nuts3_cod: e.values?.nuts3?.codigo ?? undefined,
      massa_agua_id: e.values?.massaagua ? e.values.massaagua.id : undefined,
      status: e.values?.estado ? e.values?.estado.valor : undefined,
      volume: e.values?.volume ?? undefined,
      criterio_geografico: e?.values?.rbCriterio ?? undefined,
      hasGeom: e?.values?.hasGeom,
      flatCoordinates: coordenadasPoligono,
      data_inicio_de: e?.values?.data_inicio_de ?? undefined,
      data_inicio_para: e?.values?.data_inicio_para ?? undefined,
      data_fim_de: e?.values?.data_fim_de ?? undefined,
      data_fim_para: e?.values?.data_fim_para ?? undefined,
      id_entidade: e?.values?.entidade_responsavel ? e?.values?.entidade_responsavel.id : undefined,
      entidade_tecnico_id: e?.values?.entidade_tecnico ? e?.values?.entidade_tecnico?.id : undefined,
      data_de_registo: e.values?.data_de_registo ? new Date(e.values?.data_de_registo) : undefined,
      data_ate_registo: e.values?.data_ate_registo ? new Date(e.values?.data_ate_registo) : undefined,
      data_de_mobilizacao: e.values?.data_de_mobilizacao ? new Date(e.values?.data_de_mobilizacao) : undefined,
      data_ate_mobilizacao : e.values?.data_ate_mobilizacao ? new Date(e.values?.data_ate_mobilizacao) : undefined,
      estado_id : e.values?.int_mobilizacao_estado ? e.values?.int_mobilizacao_estado?.id : undefined,
      referencia : e.values?.referencia ?? undefined,
      tipo_mob_metodo_deposicao_id : e.values?.tipo_mob_metodo_deposicao ? e.values?.tipo_mob_metodo_deposicao?.id : undefined,
      tipo_metodo_dragagem_id : e.values?.tipo_metodo_dragagem_id ? e.values?.tipo_metodo_dragagem_id?.id : undefined,
      tipo_mancha_nivel_2_id : e.values?.tipo_mancha_nivel_2_id ? e.values?.tipo_mancha_nivel_2_id?.id : undefined,
      tipo_mob_objetivo_dep_1_id : e.values?.tipo_mob_objetivo_dep_1_id ? e.values?.tipo_mob_objetivo_dep_1_id?.id : undefined,
      tipo_mob_objetivo_dep_2_id : e.values?.tipo_mob_objetivo_dep_2_id ? e.values?.tipo_mob_objetivo_dep_2_id?.id : undefined,
      tecnico_id: e.values?.tecnico_responsavel?.id ?? undefined,
      n_filedoc: e.values?.numero_processo_filedoc ?? undefined,
      id_user_logged: loggedUser?.user?.id,
      entidadeAssociada : loggedUser?.user?.entidadeId

        }

     SessionStorageService.setItem("lastSearchMobilizacao", objToSearch);
     SessionStorageService.setItem("firstCallMobilizacao", true);
     
    const result: any[] = await getMobilizacao(objToSearch);
    setCoordenadasPoligono(undefined);
   // if (result) {
      SessionStorageService.setItem(
        'resultadoMobilizacaoPesquisa',
        JSON.stringify(result)
      )
      postMessage(
        { type: 'resultadoMobilizacaoPesquisaChange', value: result },
        '*'
      )

      // const idsCaracteristicas : any[] = [];
      // result.forEach((item: any) => {
      //   if (item.lstMobilizacoesCaracteristicasIds && item.lstMobilizacoesCaracteristicasIds.length > 0) {
      //    idsCaracteristicas.push(item.lstMobilizacoesCaracteristicasIds)
      //   }
      // })
      // const iframe: any = document.getElementById('iframeGeoPortal')
      // iframe.contentWindow?.postMessage({ type: "SiarlMobilizacaoCaraterizacaoSearch", value: idsCaracteristicas }, '*')
      
    //}
  }

  type combosKeys = 'mobilizacaoFuncoes'
  |'tipologiaMob' |'deposicaoLocal1'|'deposicaoLocal2' | 'mobilizacaoEstado'
  | 'entidades' | 'mancha1' | 'mancha2' | 'deposicaoObjetivo1' | 'metotodoDragagem' | 'metodoDeposicao' | 'deposicaoObjetivo2'
  ;
  const [combos, setCombos] = useState<any>({
    mobilizacaoFuncoes, 
    tipologiaMob,
    deposicaoLocal1,
    deposicaoLocal2,
    mobilizacaoEstado,
    entidades,
    mancha1,
    mancha2,
    deposicaoObjetivo1,
    deposicaoObjetivo2,
    metotodoDragagem,
    metodoDeposicao
  })
  const setDataOption: Record<combosKeys, { setFn: any, data: any[] }> = {
    mobilizacaoFuncoes: { setFn: setCombos, data: mobilizacaoFuncoes },
    tipologiaMob: { setFn: setCombos, data: tipologiaMob },
    deposicaoLocal1: { setFn: setCombos, data: deposicaoLocal1 },
    deposicaoLocal2: { setFn: setCombos, data: deposicaoLocal2 },
    mobilizacaoEstado: { setFn: setCombos, data: mobilizacaoEstado },
    entidades: { setFn: setCombos, data: entidades },
    mancha1: { setFn: setCombos, data: mancha1 },
    mancha2: { setFn: setCombos, data: mancha2 },
    deposicaoObjetivo1: { setFn: setCombos, data: deposicaoObjetivo1 },
    deposicaoObjetivo2: { setFn: setCombos, data: deposicaoObjetivo2 },
    metotodoDragagem: { setFn: setCombos, data: metotodoDragagem },
    metodoDeposicao: { setFn: setCombos, data: metodoDeposicao },
    
  };

  const filterCombo_Multiselect = (e: any, tipoCombo: combosKeys) => {
    const { setFn, data } = setDataOption[tipoCombo];
      setFn({
          ...combos,
          [tipoCombo]: filterBy(data?.slice()??[], e.filter)
      }
      );
}

const changeDeposicaoNivel1 = (e:any) => {
  const id = e?.value?.id;
  const deplst = deposicaoObjetivo2.filter(x => x.id_int_mob_objetivo_dep_nivel_1 == id);
  setDeposicaoNivel1Selected(e.value);
  setDeposicaoNive2Filtred(deplst);
}

const handleTipologiaChange = (e: any) => {
  if (e.value?.descricao?.toUpperCase() == "EXTRAÇÃO") {
    setTipologiaExtracaoSelected(true);
    setTipologiaDeposicaoSelected(false);
  } 
  else if (e.value?.descricao?.toUpperCase() == "DEPOSIÇÃO") {
    setTipologiaExtracaoSelected(false);
    setTipologiaDeposicaoSelected(true);
  } else {
    setTipologiaDeposicaoSelected(false);
    setTipologiaExtracaoSelected(false);
  }
}

const CustomCalendar = (props: MultiViewCalendarProps) => {
  return <MultiViewCalendar {...props} views={1} />
}

const canSeeMobilizacao = hasPermission(PERMISSION_INTERVENCAO_PERFIL_BASICO) ||
                          hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
                          hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA) ||
                          hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) ||
                          hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA) ||
                          hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL);
  return (
    <Form
      onSubmitClick={handleSubmit}
      render={(formRenderProps: FormRenderProps) => (
        <>
          <FormElement className={styles.form}>
            <fieldset>
              <legend>
                <button
                  type="button"
                  className={styles.itemExpandBase}
                  onClick={toggleRegisto}
                >
                  <div className={styles.btn_Expandir_Colapsar}>
                    <span
                      className={
                        registoVisible
                          ? 'icon-siarl icon-colapsar'
                          : 'icon-siarl icon-expandir'
                      }
                    />
                  </div>
                  <span className={styles.fieldsetTitulo}>Registo</span>
                </button>
              </legend>

              {registoVisible && (
                <div className={styles.espacoVerticalFieldSet}>
                  <div className={styles.fields}>
                    <div>
                      <Field name="id" label="ID" component={Input} />
                    </div>

                    <div>
                      <Field
                          name="int_mobilizacao_estado"
                          label="Estado"
                          component={ComboBox}
                          textField="descricao"
                          filterable={true}
                          onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'mobilizacaoEstado')}}
                          data={combos?.mobilizacaoEstado}
                        />
                    </div>

                    <div>
                      <Field
                        name="filedoc_cod"
                        label="Nº Processo APA"
                        component={Input}
                        maxLength={25}
                      />
                      </div>
                  </div>

                  <div className={styles.fields}>
                  <div>
                      <Field
                        name="tecnico_responsavel"
                        label="Técnico de registo"
                        component={ComboBox}
                        textField={'userName'}
                        filterable={true}
                        onFilterChange={filterChangeTecnicos}
                        data={tecnicosData}
                      />
                    </div>
                    <div>
                    <Field
                      name="entidade_tecnico"
                      label="Entidade"
                      component={ComboBox}
                      textField={'nome'}
                      filterable={true}
                      onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'entidades')}}
                      data={combos?.entidades}
                    />
                  </div>
                  </div>
                  <div className={styles.fields}>
                  <div>
                          <Field
                            name="data_de_registo"
                            label="Data Registo De"
                            component={DateTimePicker}
                            format="dd/MM/yyyy HH:mm"
                          />
                    </div>

                    <div>
                          <Field
                            name="data_ate_registo"
                            label="Data Registo Até"
                            component={DateTimePicker}
                            format="dd/MM/yyyy HH:mm"
                          />
                    </div>
                  </div>
                </div>
              )}
            </fieldset>
            <fieldset>
              <legend>
                <button
                  type="button"
                  className={styles.itemExpandBase}
                  onClick={toggleIdentificacao}
                >
                  <div className={styles.btn_Expandir_Colapsar}>
                    <span
                      className={
                        identificacaoVisible
                          ? 'icon-siarl icon-colapsar'
                          : 'icon-siarl icon-expandir'
                      }
                    />
                  </div>
                  <span className={styles.fieldsetTitulo}>Identificação</span>
                </button>
              </legend>
              {identificacaoVisible && (
                <div className={styles.espacoVerticalFieldSet}>
                    <div className={styles.fields}>
                <div>
                  <Field 
                    name="descricao"
                    label="Designação"
                    component={Input}
                    maxLength={255}
                  />
                </div>
              </div>
                  <div className={styles.fields}>
                    <div>
                    <Field
                      name="data_inicio_de"
                      label="Data de início De"
                      format="dd/MM/yyyy"
                      component={DatePicker}
                      calendar={CustomCalendar}
                    />
                  </div>
                  <div>
                  <Field
                      name="data_inicio_para"
                      label="Data de inicio Até"
                      format="dd/MM/yyyy"
                      component={DatePicker}
                      calendar={CustomCalendar}
                    />
                    
                  </div>
                </div>
                <div className={styles.fields}>
                    <div>
                    <Field
                      name="data_fim_de"
                      label="Data de conclusão de"
                      format="dd/MM/yyyy"
                      component={DatePicker}
                      calendar={CustomCalendar}
                    />
                  </div>
                  <div>
                  <Field
                      name="data_fim_para"
                      label="Data de conclusão até"
                      format="dd/MM/yyyy"
                      component={DatePicker}
                      calendar={CustomCalendar}
                    />
                    
                  </div>
                  
              </div>
              <div className={styles.fields}>
              <div>
                    <Field
                      name="entidade_responsavel"
                      label="Entidade responsável"
                      component={ComboBox}
                      textField={'nome'}
                      filterable={true}
                      onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'entidades')}}
                      data={combos?.entidades}
                    />
                  </div>

                  <div>
                  <Field
                          name="referencia" 
                          label="Referência"
                          component={Input}
                          maxLength={150}
                    />
                    </div>
                </div>
                  <div className={styles.fields}>
                  
                      <div>
                        <Field
                          component={Input}
                          maxLength={25}
                          name="volume"
                          label="Volume em m³"
                          type='number'
                        />
                      </div>
                    </div>
                   
                    
              <>
                          <div>
                            <Field
                              component={Input}
                              maxLength={255}
                              name={'batimetrica'}
                              label={'Batimétrica'}
                              placeholder='Batimétrica'
                              type='text'
                            />
                          </div>
                          </>
                          <></>
                  
                </div>
              )}
            </fieldset>

            <fieldset>
              <legend>
                <button
                  type="button"
                  className={styles.itemExpandBase}
                  onClick={toggleTipologia}
                >
                  <div className={styles.btn_Expandir_Colapsar}>
                    <span
                      className={
                        tipologiaVisible
                          ? 'icon-siarl icon-colapsar'
                          : 'icon-siarl icon-expandir'
                      }
                    />
                  </div>
                  <span className={styles.fieldsetTitulo}>Tipologia</span>
                </button>
              </legend>
              {tipologiaVisible && (
                <div className={styles.espacoVerticalFieldSet}>
                
                  <div className={styles.fields}>
                    <div>
                        <Field
                          name="tipo_mo"
                          label="Tipo de mobilização (Extração ou Deposição)"
                          component={ComboBox}
                          textField={'descricao'}
                          data={tiposMobilizacao}
                          onChange={(e: any) => {
                            setTipologia(e.value)
                            handleTipologiaChange(e);
                          }}
                        />
                      </div>
                      <div>
                        <Field
                          component={Input}
                          maxLength={25}
                          name="volume"
                          label="Volume em m³"
                          type='number'
                        />
                      </div>
                    </div>
                    <div className={styles.fields}>
                    <div>
                      <Field
                        name="tipo_mob_objetivo_dep_1_id"
                        label="Objetivo nivel 1"
                        textField={'descricao'}
                        component={ComboBox}
                        value={deposicaoNivel1Selected}
                        onChange={changeDeposicaoNivel1}
                        filterable={true}
                        onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'deposicaoObjetivo1')}}
                        data={combos?.deposicaoObjetivo1}                        
                      />
                    </div>
                    <div>
                    <Field
                        component={ComboBox}
                        name="tipo_mob_objetivo_dep_2_id"
                        label="Objetivo nivel 2"
                        textField={'descricao'}
                        data={combos?.deposicaoObjetivo2}       
                        onFilterChange={(e:any)=>{filterCombo_Multiselect(e,'deposicaoObjetivo2')}}
                        value={deposicaoNivel2Selected}
                        onChange={(e) => {
                          setDeposicaoNivel2Selected(e?.value)
                        }}
                      />
                    </div>
                    </div>
                    {tipologiaExtracaoSelected ? 
              <>
              
              <div className={styles.fields}>
              <div>
                          <Field
                            component={ComboBox}
                            name="tipo_metodo_dragagem_id"
                            label="Método de extração"
                            textField={'descricao'}
                            filterable={true}
                            onFilterChange={(e: any) => { filterCombo_Multiselect(e, 'metotodoDragagem') } }
                            data={combos?.metotodoDragagem}
                             />
                        </div><div>
                            <Field
                              component={ComboBox}
                              name="tipo_mancha_nivel_2_id"
                              label="Tipo de mancha de empréstimo"
                              textField={'descricao'}
                              filterable={true}
                              onFilterChange={(e: any) => { filterCombo_Multiselect(e, 'mancha2') } }
                              data={combos?.mancha2}
                               />
                          </div>
                          </div>
                          </>
              : 
              tipologiaDeposicaoSelected ?
              <>
              <div className={styles.fields}>
              <div>
                          <Field
                          component={ComboBox}
                            name="tipo_mob_metodo_deposicao"
                            label="Método de Deposição"
                            textField={'descricao'}
                            filterable={true}
                            onFilterChange={(e: any) => { filterCombo_Multiselect(e, 'metodoDeposicao') } }
                            data={combos?.metodoDeposicao}                             />
                        </div><div>
                            <Field
                            component={ComboBox}
                              name="tipo_local_deposicao_1_id"
                              label="Tipo de local de deposição"
                              textField={'descricao'}
                              filterable={true}
                              onFilterChange={(e: any) => { filterCombo_Multiselect(e, 'deposicaoLocal1') } }
                              data={combos?.deposicaoLocal1}
                              />
                          </div>
                          </div>
                        
                          </>
                          : <></>
              }
                </div>
              )}
            </fieldset>

            <fieldset>
              <legend>
                <button
                  type="button"
                  className={styles.itemExpandBase}
                  onClick={toggleCriterioGeografico}
                >
                  <div className={styles.btn_Expandir_Colapsar}>
                    <span
                      className={
                        criterioGeograficoVisible
                          ? 'icon-siarl icon-colapsar'
                          : 'icon-siarl icon-expandir'
                      }
                    ></span>
                  </div>
                  <span className={styles.fieldsetTitulo}>
                    Critério geográfico
                  </span>
                </button>
              </legend>
              {criterioGeograficoVisible ? (
                <div className={styles.fields}>
                  <Field
                    id={'rbCriterio'}
                    name={'rbCriterio'}
                    layout={'horizontal'}
                    component={RadioGroup}
                    onChange={(e) => {
                      changerbCriterio(e)
                  }} 
                    data={[
                      { label: 'Nenhum', value: 0},
                      { label: 'Área visível', value: 1 },
                      { label: 'Polígono de seleção', value: 2 },
                    ]}
                    defaultValue={0} // Set the default selected value to 0 (Nenhum)

                  />
                </div>
              ) : (
                <></>
              )}
            </fieldset>
           <FieldsetCombosLocalizacao styles={styles} havePraia={true} isPesquisaAvancada={true} formRenderProps={formRenderProps}></FieldsetCombosLocalizacao>
          </FormElement>

          <div
            className={`${styles.footer} ${styles.justify_multiple_children}`}
          >
            <Button
              onClick={() => { formRenderProps.onFormReset(); clearMap()}}
              className={styles.btnLimparPesquisa}
              title='Limpar pesquisa'
            >
              <span className="icon-siarl icon-limparcampos"></span>
              <span className={styles.rotulo}>
                {' '}&nbsp;{' '}
                Limpar pesquisa
              </span>        
            </Button>

            <Button
              onClick={formRenderProps.onSubmit}
              className={styles.btnPesquisar}
              title='Pesquisar'
            >
              <span className="icon-siarl icon-pesquisar"></span>
              <span className={styles.rotulo}>
                {' '}&nbsp;{' '}
                Pesquisar
              </span> 
            </Button>
          </div>
        </>
      )}
    />
  )
}

